import script from "./AgentSkills.vue?vue&type=script&lang=ts&setup=true"
export * from "./AgentSkills.vue?vue&type=script&lang=ts&setup=true"

import "./AgentSkills.vue?vue&type=style&index=0&id=6eb87e00&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6eb87e00"]])

export default __exports__